module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// EventCalendarViewer Widget

(function (fox, $) {
	'use strict';
	
	fox.registerWidget('Activity_EventCalendarViewerNew', {

		configure: function () {
			this.defApiConf = {
				widget: 'Api',
				method: 'Activity_Event.get',
				sendTimezone: true,
				cacheChannel: 'event'
			};

			this.registerOptions('', {
				cacheRecordLimit: 500,
				returnNewFormat: true,
				additionalApiParams: {
					transitParameters: {
						v1: 'a3NPKt70Ku'
					}
				},
				list: {
					columns: ['#firts-column']
				},
				widgets: {
					eventFilter: {
						widget: 'Activity_Event_FilterNew',
						limit: 9
					},
					eventList: {
						widget: 'Activity_Event_List',
						wClass: 'Activity_Event_MainEventNew'
					},
					getDataApi: this.defApiConf
				},
				handleWom: {
					filterChanged: {
						event: 'filterChanged',
						widget: '#eventFilter',
						callback: 'filterChanged',
						params: {
							alwaysActive: true,
							listenHistory: true
						}
					},
					getDataApiSuccess: {
						event: 'success',
						widget: '#getDataApi',
						callback: 'getDataApiSuccess'
					},
					prepareApi: {
						event: 'prepare',
						widget: '.Api',
						callback: function (obj, performer) {
							// console.time(performer.getAlias());
						}
					},
					liveshowSocketInbox: {
						event: 'inboxSocketEventLiveshow:connect',
						widget: '@root #socket',
						callback: '#eventFilter:dispatchData'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.CACHE = {};

			this.registerOptions('#eventFilter #filter1', this.getOption('filter1'));
			this.registerOptions('#eventFilter #filter2', this.getOption('filter2'));
			this.registerOptions('#eventList', this.getOption('list'));
		
			this.callParent('init', arguments);
		},

		getCachedApi: function () {
			return this.embedWidget(['api', fox.uniqid()].join('_'), 'Api', fox.merge({
				handleWom: {
					apiSuccess: {
						event: 'success',
						widget: '@this',
						callback: '@parent:cachedApiSuccess'
					},
					apiFail: {
						event: ['error', 'failure'],
						widget: '@this',
						callback: function (o, api) {
							api.removeSelf();
						}
					}
				}
			}, this.defApiConf)).run();
		},

		running: function () {
			this.list = this.rwom1('#eventList');
			this.filter = this.rwom1('#eventFilter');
			this.api = this.rwom1('#getDataApi');

			this.callParent('running', arguments);
		},

		getCacheHash: function (params) {
			var cl;

			cl = fox.clone(params);

			cl.types = JSON.stringify(cl.types);

			return window.btoa(fox.toArray(cl).join(':'));
		},

		getEvents: function (params) {
			var additionalParams = this.getOption('additionalApiParams');

			if (!fox.isEmpty(additionalParams)) {
				params = fox.merge(params, additionalParams);
			}

			this.api.sendHash = this.getCacheHash(params);
			this.api.send(params);
		},

		getDataApiSuccess: function (resp, api) {
			var res = resp.answer.response;

			this.hookWrapper('prepareResponse', {response: res});
			
			this.renderList(res);
			this.dispatchEvent('eventsApiSuccess', res);
		},

		prepareResponse: function (data) {}, 

		renderList: function (collection) {
			if(!this.dontFirstRender) {
				var c = this.list.getOption('container') || this.list.getOption('embed.container');
				fox.each(this.list.getOption('columns'), function (val, i) {
					$(c).find(val).empty();
				});

				this.dontFirstRender = true;
			}

			this.list.setCollection(collection.collection);
		},

		cachedApiSuccess: function (res, api) {
			res = res.answer.response;
			this.addCache(res, api.sendHash);

			api.removeSelf();
		},

		filterChanged: function (params) {
			var cp = this.getCacheHash(params);

			if (this.CACHE.hasOwnProperty(cp)) {
				this.renderList(this.CACHE[cp]);
				this.dispatchEvent('getDataFromCache', this.CACHE[cp]);
				return;
			}

			if (this.getOption('returnNewFormat')) {
				params.returnNewFormat = true;
			}

			this.getEvents(params);

			return;
		},

		
		addCache: function (collection, cHash) {
			if (fox.count(this.CACHE) > this.getOption('cacheRecordLimit')) {this.clearCache();}

			this.CACHE[cHash] = collection;

			return this;
		},

		clearCache: function () {
			var cacheRecords, deadLine;

			cacheRecords = fox.count(this.CACHE);
			deadLine = parseInt(cacheRecords * 0.1);

			fox.each(this.CACHE, function (val, key) {
				if ((cacheRecords--) > deadLine) {
					delete this.CACHE[key];
				}
			}, this);
		}

	}, 'Controller');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/activity/eventCalendarViewerNew.js
// module id = 810
// module chunks = 4